import { FC } from 'react';
import { Center } from '@chakra-ui/react';

import useCompanyContext from 'common/hooks/useCompanyContext';
import { useCompanyProfile } from 'common/hooks/useCompanyProfile';
import SunshineLoader from 'components/_core/SunshineLoader';

import { useTaxForecastData } from '../../hooks/useTaxForecastData';
import MicroEstimationFlow from './components/MicroEstimationFlow';

const MicroEstimation: FC = () => {
  const { companyProfileId } = useCompanyContext();
  const { company, loading: companyLoading } =
    useCompanyProfile(companyProfileId);
  const {
    currentTaxForecastPeriod,
    loading: taxForecastDataLoading,
    taxForecastProfile,
  } = useTaxForecastData();

  if (companyLoading || taxForecastDataLoading) {
    return (
      <Center height="full">
        <SunshineLoader />
      </Center>
    );
  }

  //todo: CAC-244 Implement error screen
  if (!company) {
    return null;
  }

  return (
    <MicroEstimationFlow
      companyProfile={company}
      taxForecastPeriod={currentTaxForecastPeriod}
      taxForecastProfile={taxForecastProfile ?? undefined}
    />
  );
};

export default MicroEstimation;
